import { AfterViewInit, Directive, OnDestroy } from "@angular/core";
import { ButtonDirective as PrimeNGButtonDirective } from "primeng/button";
import { ClickListenerProvider } from "./click-listener-provider";

@Directive({
  selector: "[pButton]",
  standalone: true,
  host: {
    class: "p-element",
  },
})
export class ButtonDirective extends PrimeNGButtonDirective implements AfterViewInit, OnDestroy {
  private readonly listenerProvider = new ClickListenerProvider("ButtonDirective");

  get nativeElement(): HTMLElement {
    return this.el.nativeElement;
  }

  override ngAfterViewInit(): void {
    this.nativeElement.addEventListener("click", this.listenerProvider.listener, true);
    super.ngAfterViewInit();
  }

  override ngOnDestroy(): void {
    this.nativeElement.removeEventListener("click", this.listenerProvider.listener, true);
    super.ngOnDestroy();
  }
}
